import { nodeApi, nodeApi3 } from './../config'
import { getTokenNode } from '../../store/utils/tokenNode'
import vehicleResources from './vehicleResources'
import cakeLegacy from './cakeLegacy'

// Eventos de carro/condutor: o lote do front manda até 10 reservas por chamada
// e cada uma pode esperar o lock da reserva na API
const BOOKING_EVENT_TIMEOUT_MS = 60000

export default {
  /*
    register(form) {
      return nodeApi.post("/auth/signup/", {
        name: form.name,
        email: form.email,
        phone: form.phone,
        cpf: form.cpf_cnpj,
        password: form.password,
        pid: form.pid,
      });
    },
    login(username, password) {
      return nodeApi.post("/auth/signin/", {
        username: username,
        password: password
      });
    },
    */
  loginv2(username, password) {
    return nodeApi3.post('/auth/signin/', {
      username: username,
      password: password,
    })
  },

  registerV2(form) {
    return nodeApi3.post('/auth/signup/', {
      name: form.name,
      email: form.email,
      phone: form.phone,
      category: form.category,
      cpf: form.cpf_cnpj,
      password: form.password,
      pid: form.pid,
    })
  },

  forgotPassword(email) {
    return nodeApi3.post('/auth/forgot-password/', {
      email: email,
    })
  },

  resetPassword(form) {
    return nodeApi3.post('/auth/reset-password/', {
      hashcode: form.hashcode,
      password: form.password,
      confirm_password: form.confirm_password,
    })
  },

  getUserDetails(uuid) {
    return nodeApi3.get(`/auth/user-details/?user_uuid=${uuid}`)
  },

  /*
  loginGoogle(authCode, pid) {
    return nodeApi.post("/auth/signin-google/", {
      code: authCode,
      pid: pid
    });
  },
  forgotPassword(user_or_email) {
    return nodeApi.post("/auth/forgotPassword/", {
      user_or_email: user_or_email
    });
  },

  getUserProductsList() {
    if (process.env.NODE_ENV != "production") {
      //Mucugê
      // return JSON.parse('[{"name":"Museu Vivo do Garimpo","localpm":["dinheiro"]},{"name":"Projeto Sempre Viva","localpm":["dinheiro"]}]');
      //PNCD
      // return JSON.parse('[{"name":"Andorinhas, Sete Quedas e Funis","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Cachoeira da Calif\u00f3rnia","localpm":null,"category":[{"name":"Andara\u00ed","slug":"andarai"},{"name":"Igat\u00fa","slug":"igatu"}]},{"name":"Cachoeira da Donana","localpm":null,"category":[{"name":"Andara\u00ed","slug":"andarai"}]},{"name":"Cachoeira da Fuma\u00e7a","localpm":null,"category":[{"name":"Palmeiras","slug":"palmeiras"},{"name":"Vale do Cap\u00e3o","slug":"vale-do-capao"}]},{"name":"Cachoeira da Fuma\u00e7a (por baixo)","localpm":null,"category":[{"name":"Palmeiras","slug":"palmeiras"},{"name":"Vale do Cap\u00e3o","slug":"vale-do-capao"}]},{"name":"Cachoeira da Fumacinha (por cima)","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Cachoeira da Matinha","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Cachoeira da Mo\u00e7a Loira","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Cachoeira das 3 Barras","localpm":null,"category":[{"name":"Andara\u00ed","slug":"andarai"}]},{"name":"Cachoeira do Bate-palmas","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Cachoeira do C\u00f3rrego de Pedra","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Cachoeira do Ramalho","localpm":null,"category":[{"name":"Andara\u00ed","slug":"andarai"}]},{"name":"Cachoeira do Sossego","localpm":null,"category":[{"name":"Len\u00e7\u00f3is","slug":"lencois"}]},{"name":"Cachoeira dos Pombos","localpm":null,"category":[{"name":"Andara\u00ed","slug":"andarai"},{"name":"Igat\u00fa","slug":"igatu"}]},{"name":"Cachoeira laranjeira","localpm":null,"category":[{"name":"Andara\u00ed","slug":"andarai"},{"name":"Igat\u00fa","slug":"igatu"}]},{"name":"Cachoeir\u00e3o por baixo","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Calixto","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Cap\u00e3o-\u00c1guas Claras","localpm":null,"category":[{"name":"Palmeiras","slug":"palmeiras"},{"name":"Vale do Cap\u00e3o","slug":"vale-do-capao"}]},{"name":"Cardoso","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Cascalheira (Planet\u00e1rio)","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Castelo","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Circuito Rio Preto-Rodas-Ponte Velha","localpm":null,"category":[{"name":"Palmeiras","slug":"palmeiras"},{"name":"Vale do Cap\u00e3o","slug":"vale-do-capao"}]},{"name":"Estrada Velha do Garimpo","localpm":null,"category":[{"name":"Len\u00e7\u00f3is","slug":"lencois"}]},{"name":"Funis","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Gerais do Vieira","localpm":null,"category":[{"name":"Palmeiras","slug":"palmeiras"},{"name":"Vale do Cap\u00e3o","slug":"vale-do-capao"}]},{"name":"Gruta do Lap\u00e3o","localpm":null,"category":[{"name":"Len\u00e7\u00f3is","slug":"lencois"}]},{"name":"Mar de Espanha e Cachoeira da Sib\u00e9ria","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Mirante do Cachoeir\u00e3o","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Mirante do Pati","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Po\u00e7o da \u00c1rvore","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Po\u00e7o do Gavi\u00e3o","localpm":null,"category":[{"name":"Palmeiras","slug":"palmeiras"},{"name":"Vale do Cap\u00e3o","slug":"vale-do-capao"}]},{"name":"Po\u00e7o dos Patos","localpm":null,"category":[{"name":"Palmeiras","slug":"palmeiras"}]},{"name":"Po\u00e7o Redondo (rio Paragua\u00e7u)","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Pon\u00e9m-\u00c1guas Claras","localpm":null,"category":[{"name":"Palmeiras","slug":"palmeiras"},{"name":"Vale do Cap\u00e3o","slug":"vale-do-capao"}]},{"name":"Purifica\u00e7\u00e3o","localpm":null,"category":[{"name":"Palmeiras","slug":"palmeiras"},{"name":"Vale do Cap\u00e3o","slug":"vale-do-capao"}]},{"name":"Rampa do Caim","localpm":null,"category":[{"name":"Andara\u00ed","slug":"andarai"}]},{"name":"Ribeir\u00e3o do Meio","localpm":null,"category":[{"name":"Len\u00e7\u00f3is","slug":"lencois"}]},{"name":"Rio Preto (at\u00e9 a Toca do Caboclo)","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Rio Preto","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Setor calif\u00f3rnia","localpm":null,"category":[{"name":"Andara\u00ed","slug":"andarai"}]},{"name":"Setor coisa boa","localpm":null,"category":[{"name":"Andara\u00ed","slug":"andarai"},{"name":"Igat\u00fa","slug":"igatu"}]},{"name":"Travessia Cachoeira do 21","localpm":null,"category":[{"name":"Len\u00e7\u00f3is","slug":"lencois"},{"name":"Vale do Cap\u00e3o","slug":"vale-do-capao"}]},{"name":"Travessia Cap\u00e3o-Len\u00e7\u00f3is","localpm":null,"category":[{"name":"Len\u00e7\u00f3is","slug":"lencois"},{"name":"Vale do Cap\u00e3o","slug":"vale-do-capao"}]},{"name":"Trilha Andara\u00ed - Igatu","localpm":null,"category":[{"name":"Andara\u00ed","slug":"andarai"}]},{"name":"Trilha da Cachoeira Capivari e Mixila","localpm":null,"category":[{"name":"Len\u00e7\u00f3is","slug":"lencois"}]},{"name":"Trilha da Cachoeira do Palmital","localpm":null,"category":[{"name":"Len\u00e7\u00f3is","slug":"lencois"}]},{"name":"Trilha da Pedra do Urubu","localpm":null,"category":[{"name":"Andara\u00ed","slug":"andarai"}]},{"name":"Trilha do Capa Bode (Cascalheira-Igatu)","localpm":null,"category":[{"name":"Andara\u00ed","slug":"andarai"},{"name":"Igat\u00fa","slug":"igatu"}]},{"name":"Trilha Fumacinha e V\u00e9u de Noiva","localpm":null,"category":[{"name":"Ibicoara","slug":"ibicoara"}]},{"name":"Trilha Pon\u00e9m-Barro Branco","localpm":null,"category":[{"name":"Len\u00e7\u00f3is","slug":"lencois"}]}]');
      //Ibicoara
      return [{"id":14385,"name":"Cachoeira do Burac\u00e3o","localpm":["credito","debito","pix"],"category":[{"name":"Ibicoara","slug":"ibicoara"}],"commission":{"commission_mode":"percent","commission_value":10,"commission_fixed":""}}]
    } else {
      return nodeApi.get("/poiList/");
    }
  },
  */

  findAllByUserRules() {
    return nodeApi.get('/issues/')
  },

  getRequerimentoById(idRequerimento) {
    return nodeApi.get(`/issues/${idRequerimento}`)
  },

  cadastrarRequerimento(detalhes, tipo) {
    //set user_id_from for test
    return nodeApi.post('/issues/', { details: detalhes, type: tipo })
  },

  getAllStatusRequerimentos() {
    return nodeApi.get('/issuesStatus')
  },

  getAllStatusDocumentos() {
    return nodeApi.get('/filesStatus')
  },

  getDetalhesStatusRequerimento(idStatus) {
    return nodeApi.get(`/issuesStatus/${idStatus}`)
  },

  updateStatusRequerimento(idRequerimento, statusId) {
    return nodeApi.put(`/issues/${idRequerimento}`, { statusId })
  },

  getTiposRequerimentos() {
    return nodeApi.get('/issuesTypes')
  },

  getTiposRequerimentosAtivos() {
    return nodeApi.get('/issuesTypes/actives')
  },

  updateTipoRequerimento(id, label, descricao) {
    return nodeApi.put(`/issuesTypes/${id}`, {
      label: label,
      description: descricao,
    })
  },

  deleteTipoRequerimento(id) {
    return nodeApi.delete(`/issuesTypes/${id}`)
  },

  cadastrarTipoRequerimento(label, descricao) {
    return nodeApi.post('/issuesTypes', {
      label: label,
      description: descricao,
    })
  },

  getDetalhesTipoRequerimento(tipo) {
    return nodeApi.get(`/issuesTypes/${tipo}`)
  },

  postDocumento(fileInfo, file) {
    return nodeApi.post('/files/create', file, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'x-access-token': getTokenNode(),
      },
      params: {
        name: fileInfo.name,
        refId: fileInfo.refId,
        ref: fileInfo.ref,
        status: fileInfo.status,
      },
    })
  },

  postFileV3(fileInfo, file) {
    if (file instanceof FormData) {
      file.append('ref', fileInfo.ref || '')
      file.append('refId', fileInfo.refId == null ? '' : String(fileInfo.refId))
      file.append('details', fileInfo.name || fileInfo.details || '')
    }
    return nodeApi3.post('files/create', file, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  updateStatusDocumento(idDocumento, statusId) {
    return nodeApi.put(`/files/${idDocumento}`, { statusId })
  },

  getDocumentos() {
    return nodeApi.get('/files')
  },

  getDocumentosByRequerimentoId(idRequerimento) {
    return nodeApi.get(`/files/${idRequerimento}/files`)
  },

  getFileByPath(filePath) {
    return nodeApi.get(`/files/public/?file_path=${filePath}`, {
      responseType: 'blob',
    })
  },

  /**
   * Arquivo na API Node v3.
   * GET /files/public/?file_path= devolve o binário quando o arquivo está
   * no disco; senão devolve o JSON do registro (id, path).
   * O binário pelo id: GET /files/download/:id
   */
  getFileByPathV3(filePath) {
    return nodeApi3.get(`files/public/?file_path=${filePath}`, {
      responseType: 'blob',
      headers: { Accept: '*/*' },
    })
  },

  downloadFileById(fileId) {
    return nodeApi3.get(`files/download/${fileId}`, {
      responseType: 'blob',
      headers: { Accept: '*/*' },
    })
  },

  downloadDocumento(fileId) {
    return nodeApi.get(`/files/download/${fileId}`, {
      responseType: 'blob',
    })
  },

  postMessage(message, title, userIdTo, issuesId) {
    return nodeApi.post('/messages', {
      message: message,
      title: title,
      userIdTo: userIdTo,
      issuesId,
      issuesId,
    })
  },

  getMessagesByIssuesId(issuesId) {
    return nodeApi.get(`/messages/issues/${issuesId}`)
  },

  deleteProduct(product_id) {
    return nodeApi.delete(`/products/${product_id}`)
  },

  /**
   *
   *    Node.js API 2.0
   *
   */

  /**
   *
   * @returns JSON list off all withdraws from current user
   */
  getWithdraws(startDate, endDate, refreshCache) {
    let url = '/withdraw?'
    if (refreshCache == true) {
      url = '/withdraw?nocache=true&'
    }else{
      // let date = new Date()
      if (startDate) {
        url += `start_date=${startDate}&`
      }
      if (endDate) {
        url += `end_date=${endDate}&`
      }
    }
    return nodeApi3.get(url)
  },

  /**
   *
   * @returns JSON list off all withdraws from current user
   */
  getWithdrawBookings(uuid) {
    return nodeApi3.get(`/withdraw/bookings?report-uuid=${uuid}`)
  },

  /**
   *
   * @returns JSON list off all withdraws payments in the payload period
   */
  getPaymentsForAttractions(payload) {
    return nodeApi3.get(
      `/admin/report/payment-for-attractions?nocache=true&start_date=${payload.startDate}&end_date=${payload.endDate}`
    )
  },

  /**
   *
   * @returns JSON list off all withdraws payments in the payload period
   */
  withdrawReport(payload) {
    return nodeApi3.post(`/withdraw/report`, payload)
  },

  /**
   * Create new register of withdraw payments for the selected period
   * @param {*} payload
   * @returns
   */
  postPaymentsForAttractions(payload) {
    return nodeApi3.post(`/admin/report/payment-for-attractions`, {
      start_date: payload.start_date,
      end_date: payload.end_date,
      save_report: true,
      places: payload.places,
    })
  },

  /**
   * Insere registro de solicitação de retirada de saldo
   *
   * @param {*} orders
   * @param {*} value
   * @returns
  */
  saveWithdraw(orders, value) {
    return nodeApi3.post('/withdraw', {
      orders: orders,
      value: value,
    })
  },

  /**
   * atualiza o produto via api
   */

  updateProduct(payload) {
    try {
      return nodeApi3.put('products/admin/update', payload, {
        headers: {
          authorization: 'L!uc@5Mi#raNdaAdM2025',
        },
      })
    } catch (error) {
      return error
    }
  },

  /**
   * Gera novo Bearer Token para Iframe Getnet
   *
   * @returns
   */
  createGetnetToken() {
    return nodeApi3.post('/getnet/token')
  },

  /**
   * Gera novo Bearer Token para Iframe Getnet
   *
   * @returns
   */
  createGetnetQRPix(form) {
    return nodeApi3.post('/getnet/generate-qr-code-pix', form)
  },

  /**
   * Reserva com pagamento recebido no local. A conta do financeiro,
   * quando o token tem o menu, é montada no servidor.
   *
   * @param {*} form JSON da reserva já montado pelo modal
   * @returns
   */
  createLocalPayment(form) {
    return nodeApi3.post('/booking/local-payment', form)
  },

  /**
   * Gera um link de pagamento Getnet
   *
   * @returns
   */
  createGetnetPaymentLink(form) {
    return nodeApi3.post('/getnet/payment-link', form)
  },

  /**
   * Salva os valores pagos localmente na reserva expressa marcada como paga
   *
   * @returns
   */
  saveLocalPayments(payments) {
    return nodeApi3.post('/booking/update-local-payments', payments)
  },

  /**
   * Carrega lista de entradas de dados do Trafx por date e uuid do usuário logado
   *
   * @param {*} form
   * @returns
   */
  getTrafxEntries(form) {
    return nodeApi3.get(
      '/trafx/entries?' +
        'uuid_gestor=' +
        form.UUID +
        '&start_date=' +
        form.start_date +
        '&end_date=' +
        form.end_date
    )
  },

  /**
   * Carrega lista de arquivos upados do Trafx
   *
   * @returns JSON com detalhes de cada arquivo
   */
  getTrafxFiles(params) {
    if (!params) {
      params = {}
    }

    if (!params.start_date) {
      params.start_date = '2022-12-01' //first date of trafx 2022-12-08
    }

    if (!params.end_date) {
      params.end_date = new Date().toISOString().substring(0, 10)
    }

    return nodeApi3.get(
      '/trafx?' +
        'start_date=' +
        params.start_date +
        '&end_date=' +
        params.end_date
    )
  },

  /**
   * Insere registros de dados Trafx
   *
   * @param {*} form
   * @returns
   */
  saveTrafx(form) {
    return nodeApi3.post('/trafx', form)
  },

  /**
   * Carrega uma lista de produtos de uma determinada categoria
   * @todo permitir parâmetro de definição da categoria
   * @param {*} formDate
   * @returns
   */
  getOperations(formDate) {
    var cat = 'Roteiro'
    return nodeApi3.get(
      '/bills/products?cat=' +
        cat +
        '&sdate=' +
        formDate.startDate +
        '&edate=' +
        formDate.endDate
    )
  },

  /**
   * Carrega os detalhes de uma reserva e informações pertinentes a ela
   * @param {String} UUID
   * @returns {*}
   */
  getBookingByUUID(UUID) {
    return nodeApi3.get(`booking/?hash=${UUID}`)
  },

  /**
   * Carrega uma lista de itens de venda (Janoo) no período determinado
   * @param {*} formDate
   * @returns
   */
  // getWPItems(params) {
  //   return nodeApi3.get(`/janoowp/bookings?start_date=${params.startDate}&end_date=${params.endDate}&bill_items_response=ok&operation_request=${params.operation_request}`);
  // },

  /**
   * Carrega uma lista de itens de venda (banco) no período determinado
   * @param {*} formDate
   * @returns
   */
  getBillItems(params) {
    let $nocache = ''
    let code = ''
    if (params.startDate >= new Date().toISOString().substring(0, 10)) {
      $nocache = '&nocache=' + new Date().getTime()
    }

    if (params.code) {
      code = `&code=${params.code}`
    }

    return nodeApi3.get(
      `/booking/byPeriod?start_date=${params.startDate}&end_date=${params.endDate}${$nocache}${code}`
    )
  },

  /**
   * Cria uma reserva expressa correspondente a uma registrada na Getnet
   * @param {*} form
   * @returns
   */
  postCreateExpressBookingGetnet(form) {
    return nodeApi3.post(process.env.VUE_APP_GETNET_URL_CALLBACK, form)
  },

  /**
   * Cria uma reserva expressa correspondente a uma registrada no Mercado Pago
   * @param {*} form
   * @returns
   */
  postCreateExpressBookingMercadoPago(form) {
    return nodeApi3.post(process.env.VUE_APP_MERCADO_PAGO_URL_CALLBACK, form)
  },

  /**
   * Adiciona condutores a uma reserva expressa
   * @param {*} payload
   * @returns
   */
  postAddBookingAgent(payload) {
    return nodeApi3.post('/booking/event', {
      action: 'booking_add_agent_handler',
      hash: payload.hash,
      payload: payload.agents,
    }, { timeout: BOOKING_EVENT_TIMEOUT_MS })
  },

  /**
   * Adiciona veículos a uma ou mais reservas
   * @param {{ hash: string | Array<string>, vehicles: Array }} payload
   * @returns
   */
  postAddBookingVehicle(payload) {
    return nodeApi3.post('/booking/event', {
      action: 'booking_add_vehicle_handler',
      hash: payload.hash,
      payload: payload.vehicles,
    }, { timeout: BOOKING_EVENT_TIMEOUT_MS })
  },

  /**
   * Grava a alocação completa de veículos de uma ou mais reservas (substitui a
   * anterior). Item sem pax = reserva inteira naquele veículo.
   * @param {{ hash: string | Array<string>, vehicles: Array<{ resource_uuid: string, pax?: number }> }} payload
   * @returns
   */
  postSetBookingVehicles(payload) {
    return nodeApi3.post('/booking/event', {
      action: 'booking_set_vehicles_handler',
      hash: payload.hash,
      payload: payload.vehicles,
    }, { timeout: BOOKING_EVENT_TIMEOUT_MS })
  },

  /**
   * Remove condutor de uma reserva expressa
   * @param {*} payload
   * @returns
   */
  postRemoveBookingAgent(payload) {
    return nodeApi3.post('/booking/event', {
      action: 'booking_remove_agent_handler',
      hash: payload.hash,
      payload: { uuid: payload.uuid },
    }, { timeout: BOOKING_EVENT_TIMEOUT_MS })
  },

  /**
   * Remove veículo de uma reserva
   * @param {{ hash: string, uuid: string }} payload
   * @returns
   */
  postRemoveBookingVehicle(payload) {
    return nodeApi3.post('/booking/event', {
      action: 'booking_remove_vehicle_handler',
      hash: payload.hash,
      payload: { uuid: payload.uuid },
    }, { timeout: BOOKING_EVENT_TIMEOUT_MS })
  },

  /**
   * Realiza checkin de uma reserva expressa
   * @param {*} payload
   * @returns
   */
  postCheckinExpressBooking(payload) {
    return nodeApi3.post('/booking/event', {
      action: 'booking_checked_in_handler',
      hash: payload.hash,
      payload: {
        keepdate: true,
      },
    })
  },

  /**
   * Realiza o cancelamento de uma reserva expressa
   * @param {*} payload
   * @returns
   */
  postCancelExpressBooking(payload) {
    return nodeApi3.post('/booking/event', {
      action: 'booking_complete_to_cancelled_handler',
      hash: payload.hash,
    })
  },

  /**
   * Realiza a mudança de quantidade de pessoas de uma reserva
   * @param {*} payload
   * @returns
   */
  postUpdateExpressBookingTickets(payload) {
    return nodeApi3.post('/booking/event', {
      action: 'booking_update_quantity_visitors',
      hash: payload.hash,
      payload: {
        tickets: payload.indexes,
        message: payload.message,
        to_wallet: payload.pixRefund == 'wallet',
        refund_type: payload.pixRefund,
        pix_code: payload.pix_code,
      },
    })
  },

  /**
   * Realiza a troca de dadta de de uma reserva
   * @param {*} payload
   * @returns
   */
  postUpdateExpressBookingDate(payload) {
    return nodeApi3.post('/booking/event', {
      action: 'booking_date_changed_handler',
      hash: payload.hash,
      payload: {
        date: payload.date,
      },
    })
  },

  /**
   * Realiza a verificação de reservas do dia (date)
   * @param {*} date
   * @returns
   */
  verifyBookings(date) {
    return nodeApi3.get(`poscontroller?date=${date}`)
  },

  /**
   * Realiza o bloqueio de reservas de determinada data
   * @param {*} payload
   * @returns
   */
  postBlockDayProduct(payload) {
    return nodeApi3.post(`/products/updateUnavailability`, {
      product_uuid: payload.product_uuid,
      unavailability: payload.unavailability,
    })
  },

  /**
   * Realiza o desbloqueio de reservas de determinada data
   * @param {*} payload
   * @returns
   */
  postUnblockDayProduct(payload) {
    return nodeApi3.post(`/products/updateUnavailability`, {
      action: 'remove',
      product_uuid: payload.product_uuid,
      unavailability: payload.unavailability,
    })
  },

  /**
   * Fecha uma transação
   * @param {*} payload
   * @returns
   */
  closeTransaction(payload) {
    return nodeApi3.delete(`finance/${payload.general.id}`)
  },

  /**
   * Transmite uma transação
   * @param {*} payload
   * @returns
   */
  sendTransaction(payload) {
    return nodeApi3.post('finance/transmit-note', {
      transactionId: payload.general.id,
    })
  },

  /**
   * Cria/Edita uma nova transação
   * @param {*} payload
   * @returns
   */
  postTransaction(payload) {
    let endpoint = `/finance`

    if (payload.general.id > 0) {
      endpoint = `/finance/${payload.general.id}`
      return nodeApi3.put(endpoint, payload)
    } else {
      return nodeApi3.post(endpoint, payload)
    }
  },

  /**
   * Carrega uma transação pelo PID
   * @param {*} payload
   * @returns
   */
  getTransactionById(payload) {
    return nodeApi3.get(`/finance/` + payload.pid, {
      type: payload.type,
    })
  },

  /**
   * Carrega uma lista de itens do relatório de entradas financeiras
   * @param {*} formDate
   * @returns
   */
  getFinanceBookingReportData(params) {
    return nodeApi3.get(
      `/finance/report/booking?startDate=${params.startDate}&endDate=${params.endDate}`
    )
  },

  /**
   * Dispara para servidor enviar mensagem via Whatsapp
   *
   * @param {*} message
   * @returns
   */
  postWhatsappMessage(message) {
    return nodeApi3.post('/messenger/send-whatsapp', {
      typeMessage: message.typeMessage,
      messageBody: message.messageBody,
    })
  },
  /**
   * Agenda mensagem para Whatsapp
   *
   * @param {*} message
   * @returns
   */
  scheduleWhatsappMessage(message) {
    let endpoint = '/messenger/schedule'
    return nodeApi3.post(endpoint, [message])
  },

  /**
   * Lista modelos de notificação (status=3) da unidade + globais.
   * GET /messenger/models (JWT)
   */
  getMessengerModels() {
    return nodeApi3.get('/messenger/models')
  },

  /**
   * Cria ou atualiza um campo em message_data do modelo.
   * PUT /messenger/models/:uuid/fields (JWT)
   * Body: { name: string, label?: string }
   *
   * @param {string} modelUuid
   * @param {{ name: string, label?: string }} payload
   */
  upsertMessengerModelField(modelUuid, payload) {
    return nodeApi3.put(`/messenger/models/${modelUuid}/fields`, {
      name: payload && payload.name,
      label: payload && payload.label,
    })
  },

  /**
   * Fetchs all public products (POIs)
   *
   * @param {*} place_uuid
   * @returns
   */
  getPublicProducts(place_uuid) {
    let url = '/products/public'
    url = place_uuid ? url + `/?place_uuid=${place_uuid}` : url
    return nodeApi3.get(url)
  },

  /**
   * Lista mockada de recursos de veículo do produto.
   *
   * @returns {Promise<{ data: Array }>}
   */
  getVehicleResources() {
    return Promise.resolve({
      data: vehicleResources.map((vehicle) => ({ ...vehicle })),
    })
  },

  /**
   * Atualiza os recursos de um bloco de horário do produto.
   * A API soma ou remove a capacidade dos veículos no capacity do produto.
   *
   * @param {string} productUuid
   * @param {{ block: string, product_uuid: string, resources: Array }} payload
   * @returns {Promise}
   */
  updateProductResources(productUuid, payload) {
    return nodeApi3.patch(`/products/${productUuid}/resources`, payload)
  },

  /**
   * Atualiza os xfields da unidade autenticada.
   *
   * @param {string} placeUuid
   * @param {Object} xfields
   * @returns {Promise}
   */
  updatePlaceXFields(placeUuid, xfields) {
    return nodeApi3.put(`places/${placeUuid}/xfields`, xfields)
  },

  getPlacePublicData(placeUuid) {
    return nodeApi3.get(`places/${placeUuid}/public_data`)
  },

  /**
   * Credenciais Getnet da unidade (ROAD-909). A API devolve apenas valores
   * mascarados; o valor real nunca chega ao front.
   *
   * @param {string} placeUuid
   * @returns {Promise}
   */
  getPlaceGetnetCredentials(placeUuid) {
    return nodeApi3.get(`places/${placeUuid}/integrations/getnet`)
  },

  /**
   * Salva credenciais Getnet da unidade. Atualizacao parcial: campo omitido
   * mantem o valor salvo, string vazia apaga a chave.
   *
   * @param {string} placeUuid
   * @param {{client_id?: string, client_secret?: string, seller_id?: string}} body
   * @returns {Promise}
   */
  savePlaceGetnetCredentials(placeUuid, body) {
    return nodeApi3.put(`places/${placeUuid}/integrations/getnet`, body)
  },

  /**
   * Remove todas as credenciais Getnet da unidade.
   *
   * @param {string} placeUuid
   * @returns {Promise}
   */
  deletePlaceGetnetCredentials(placeUuid) {
    return nodeApi3.delete(`places/${placeUuid}/integrations/getnet`)
  },

  /**
   * Carrega lista de produtos do vendedor (POIs)
   *
   * @param {*} vendor_uuid
   * @returns
   */
  async getPoisByVendor(payload) {
    const nocache = payload.nocache ? '&nocache=true' : ''
    return await nodeApi3.get(
      '/products/poi/?place_uuid=' +
        payload.PLACE_UUID +
        '&product_uuid=' +
        payload.PRODUCT_UUID +
        nocache
    )
  },

  getProductsByPlace(placeUuid) {
    return nodeApi3.get('/products/all?place_uuid=' + placeUuid)
  },

  /**
   * Envia ping para os visitantes da pesquisa de satisfação
   *
   * @param {*} payload
   * @returns
   */
  pingSurveyVisitors(payload) {
    return nodeApi3.post('/survey/ping/?product_uuid=' + payload.PRODUCT_UUID + '&collector_id=' + payload.COLLECTOR_ID)
  },

  /**
   * Carrega lista respostas da pesquisa de satisfação para os produtos do gestor
   *
   * @param {*} vendor_uuid
   * @returns
   */
  getProductNps(productUuid) {
    return nodeApi3.get(
      '/survey/product/' + encodeURIComponent(productUuid) + '/nps'
    )
  },

  async getNPSData(payload) {
    let url = new URL('/survey/nps-report', window.location.origin)

    url.searchParams.set('start_date', payload.startDate)
    url.searchParams.set('end_date', payload.endDate)

    if (payload.product_uuid) {
      url.searchParams.set('product_uuid', payload.product_uuid)
    }

    if (payload.place_uuid) {
      url.searchParams.set('place_uuid', payload.place_uuid)
    }

    if (payload.vendor_email) {
      url.searchParams.set('vendor_email', payload.vendor_email)
    }

    return await nodeApi3.get(url.pathname + url.search)
  },

  /**
   * Registra uma resposta da pesquisa de satisfação (mesmo endpoint do webhook Zoho).
   * Rota pública: POST /api/v3/survey
   *
   * @param {Object} payload
   * @returns {Promise}
   */
  registerSurveyResponse(payload) {
    return nodeApi3.post('/survey', payload)
  },

  /**
   * Carrega lista de produtos do vendedor (atrativos)
   *
   * @param {*} vendor_uuid
   * @returns
   */
  getProductsByVendor(vendor_uuid) {
    return nodeApi3.get('/products/gestor/?vendor_uuid=' + vendor_uuid)
  },

  /**
   * Carrega produtos pelo UUID
   *
   * @param {*} vendor_uuid
   * @returns
   */
  async getProduct(product_uuid) {
    if (product_uuid == undefined) {
      return {}
    }

    let product = await nodeApi3.get('/products/all?uuid=' + product_uuid)

    let productData = product.data

    let xfieldsData = productData.xfields
    xfieldsData =
      typeof xfieldsData === 'string' ? JSON.parse(xfieldsData) : xfieldsData

    let laravel_data = {}
    if (
      xfieldsData.laravel_data != undefined &&
      typeof xfieldsData.laravel_data == 'object'
    ) {
      let parsed_laravel_data = {}
      try {
        parsed_laravel_data = JSON.parse(xfieldsData.laravel_data.value)
        delete xfieldsData.laravel_data
      } catch (error) {}

      Object.keys(parsed_laravel_data).forEach((key) => {
        laravel_data[key] = {}
        laravel_data[key]['value'] = parsed_laravel_data[key]
        laravel_data[key]['laraveldata'] = true
      })
    }
    productData.xfields = {}
    productData.xfields['laravel_data'] = laravel_data
    return productData
  },

  /**
   * Carrega lista de reservas disponíveis para importação (leads)
   *
   * @returns
   */
  getLeads() {
    return nodeApi3.get('/booking/leads')
  },

  /**
   * Busca assinaturas/dados de clientes do termo pelo hash
   * @param {string} hash
   * @returns
   */
  getTermSignatures(hash) {
    return nodeApi3.get(`/terms/${hash}`)
  },

  /**
   * Salva assinaturas do termo
   * @param {{ hash: string, clients: Array, datetime: string }} payload
   * @returns
   */
  saveTermSignatures(payload) {
    return nodeApi3.post('/terms/', payload)
  },

  /**
   * Admin Mensageria — opções de filtro.
   * GET /messenger/admin/filters (ADMIN_IDS)
   * gestores: usertype=janoo → place uuid; products: sale_unit=Passeio
   */
  getMessengerAdminFilters() {
    return nodeApi3.get('/messenger/admin/filters')
  },

  /**
   * Admin Mensageria — estatísticas do período (por modelo e horário).
   * GET /messenger/admin/stats?start_date&end_date&place_uuid?&product_uuid?
   *
   * @param {{ start_date: string, end_date: string, place_uuid?: string, product_uuid?: string }} params
   */
  getMessengerAdminStats(params = {}) {
    return nodeApi3.get('/messenger/admin/stats', { params })
  },

  /**
   * Admin Mensageria — modelos = `notifications` com status=3 (+ mapa MODELO_*).
   * GET /messenger/admin/models (ADMIN_IDS)
   * Não usa a tabela messages nem a fila de disparos.
   */
  getMessengerAdminModels() {
    return nodeApi3.get('/messenger/admin/models')
  },

  /**
   * Admin Mensageria — fila de disparos do período (exclui status=3).
   * GET /messenger/admin/notifications?start_date&end_date&place_uuid?&product_uuid?&status?&page?&limit?
   *
   * @param {object} params
   */
  getMessengerAdminNotifications(params = {}) {
    return nodeApi3.get('/messenger/admin/notifications', { params })
  },

  /**
   * Admin Mensageria — antecipa envio: send_date = NOW() (status=2).
   * PATCH /messenger/admin/notifications/:id/send-now
   *
   * @param {number|string} id
   */
  patchMessengerAdminNotificationSendNow(id) {
    return nodeApi3.patch(`/messenger/admin/notifications/${id}/send-now`)
  },

  /**
   * Admin Mensageria — cria disparo a partir de modelo (status=3 → status=2).
   * POST /messenger/admin/notifications
   * Body: model_uuid|model_id, title, message, send_date, to, channel
   * (API fixa from='Admin Panel', status=2, error_count=0).
   *
   * @param {{
   *   model_uuid?: string,
   *   model_id?: number,
   *   title: string,
   *   message: object|string,
   *   send_date: string,
   *   to: string,
   *   channel: string
   * }} payload
   */
  postMessengerAdminNotification(payload = {}) {
    return nodeApi3.post('/messenger/admin/notifications', payload)
  },

  /**
   * Inbox push in-app — lista do usuário (to=username, channel=push, send_date<=now).
   * GET /messenger/inbox?page&limit&unread&since
   * Auth: JWT (não exige ADMIN_IDS).
   * WS: /ws/push-inbox?token=&since= — sem since → catch-up 24h unread-only.
   *
   * @param {{ page?: number, limit?: number, unread?: boolean|string, since?: string }} params
   */
  getMessengerPushInbox(params = {}) {
    const query = { ...params }
    if (query.unread === true) query.unread = '1'
    if (query.unread === false) delete query.unread
    return nodeApi3.get('/messenger/inbox', { params: query })
  },

  /**
   * Badge de não lidas do inbox push.
   * GET /messenger/inbox/unread-count
   */
  getMessengerPushInboxUnreadCount() {
    return nodeApi3.get('/messenger/inbox/unread-count')
  },

  /**
   * Marca push como lida (message.inbox_read_at) sem alterar status da fila.
   * PATCH /messenger/inbox/:id/read
   *
   * @param {number|string} id
   */
  patchMessengerPushInboxRead(id) {
    return nodeApi3.patch(`/messenger/inbox/${id}/read`)
  },

  /**
   * Marca push como não lida (remove message.inbox_read_at) sem alterar status da fila.
   * PATCH /messenger/inbox/:id/unread
   *
   * @param {number|string} id
   */
  patchMessengerPushInboxUnread(id) {
    return nodeApi3.patch(`/messenger/inbox/${id}/unread`)
  },

  ...cakeLegacy,
}
